import * as corePixiInit from "./core/initializePixi.js";

const loadAndExecuteFunction = (func) => (...args) =>
  corePixiInit.loadGameUIFunctions()
    .then((gameUI) => gameUI[func](...args))
    .catch((error) => {
      console.error(`Error using gameUI.${func}():`, error);
      throw error;
    });

export const pixiAppResize = loadAndExecuteFunction('resizePixiApplication')
const resetPixiGame = loadAndExecuteFunction('resetPixiGame')
const resetGameSettings = loadAndExecuteFunction('resetGameSettings')

export const pixiApplicationInit = (setIsPixiAssetsLoaded) => corePixiInit.init(setIsPixiAssetsLoaded)

export const pixiAssetsLoad = () => corePixiInit.loadPixiAssets()

export const pixiApplicationDestroy = () => {
  startLoading()
  corePixiInit.destroyPixiApp()
}

export const isSimulate = false

export const start = loadAndExecuteFunction('startGame');

export const startLoading = loadAndExecuteFunction('countDownAnimation')

export const centerText = loadAndExecuteFunction('setCenterText')

export const crash = loadAndExecuteFunction('crashed')

export const createCashOut = loadAndExecuteFunction('setCashoutAmount')

export const resetGame = loadAndExecuteFunction('resetGameSettings')

export const setPercentUserCashedOut = loadAndExecuteFunction('setUserCashoutPercentage')

export const gettingSignal = loadAndExecuteFunction('getSignal')

export const changeSignalStatus = loadAndExecuteFunction('changeSignalStatus')

export const setXAxis = loadAndExecuteFunction('setXAxisValue')
